import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06971341"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "outBox"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  class: "top-bar-box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, null, -1));
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "table-box",
  ref: "tableBoxRef"
};
const _hoisted_7 = {
  key: 0,
  style: {
    "overflow": "hidden",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "height": "25px"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "城市", -1));
const _hoisted_9 = {
  key: 0,
  style: {
    "padding": "8px"
  }
};
const _hoisted_10 = {
  style: {
    "height": "300px",
    "width": "200px",
    "overflow-y": "auto",
    "overflow-x": "hidden"
  }
};
const _hoisted_11 = {
  style: {
    "padding-top": "5px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_12 = {
  key: 1,
  style: {
    "padding": "8px"
  }
};
const _hoisted_13 = {
  style: {
    "height": "200px",
    "width": "120px",
    "overflow-y": "auto",
    "overflow-x": "hidden"
  }
};
const _hoisted_14 = {
  style: {
    "padding-top": "5px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_15 = {
  key: 2,
  style: {
    "padding": "8px"
  }
};
const _hoisted_16 = {
  style: {
    "height": "200px",
    "width": "120px",
    "overflow-y": "auto",
    "overflow-x": "hidden"
  }
};
const _hoisted_17 = {
  style: {
    "padding-top": "5px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_18 = {
  key: 3,
  style: {
    "padding": "8px"
  }
};
const _hoisted_19 = {
  style: {
    "height": "200px",
    "width": "150px",
    "overflow-y": "auto",
    "overflow-x": "hidden"
  }
};
const _hoisted_20 = {
  style: {
    "padding-top": "5px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_21 = {
  key: 4,
  style: {
    "padding": "8px"
  }
};
const _hoisted_22 = {
  style: {
    "height": "300px",
    "width": "250px",
    "overflow-y": "auto",
    "overflow-x": "hidden"
  }
};
const _hoisted_23 = {
  style: {
    "padding-top": "5px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_24 = {
  key: 5,
  style: {
    "padding": "8px"
  }
};
const _hoisted_25 = {
  style: {
    "height": "300px",
    "width": "200px",
    "overflow-y": "auto",
    "overflow-x": "hidden"
  }
};
const _hoisted_26 = {
  style: {
    "padding-top": "5px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_27 = {
  key: 6,
  style: {
    "padding": "8px"
  }
};
const _hoisted_28 = {
  style: {
    "height": "300px",
    "width": "200px",
    "overflow-y": "auto",
    "overflow-x": "hidden"
  }
};
const _hoisted_29 = {
  style: {
    "padding-top": "5px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_30 = {
  style: {
    "padding": "8px"
  }
};
const _hoisted_31 = {
  style: {
    "height": "300px",
    "width": "200px",
    "overflow-y": "auto",
    "overflow-x": "hidden"
  }
};
const _hoisted_32 = {
  style: {
    "padding-top": "5px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_33 = {
  class: "bottom-pagination-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_FilterFilled = _resolveComponent("FilterFilled");
  const _component_a_cascader = _resolveComponent("a-cascader");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group");
  const _component_a_checkbox = _resolveComponent("a-checkbox");
  const _component_a_table = _resolveComponent("a-table");
  const _component_a_pagination = _resolveComponent("a-pagination");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_button, {
    class: "sts-button default",
    color: "#539ce0",
    style: {
      "width": "80px",
      "height": "25px",
      "padding": "0"
    },
    onClick: _cache[0] || (_cache[0] = $event => _ctx.getAllStoreLocationExport())
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('screenManage.export')), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_6, [_ctx.storeData1.storeLocationConditionList ? (_openBlock(), _createBlock(_component_a_table, {
    key: 0,
    columns: _ctx.columns,
    "data-source": _ctx.storeData1.data,
    border: false,
    stripe: "",
    ref: "storeTable1",
    loading: _ctx.storeLoading1,
    onHeaderCellClick: _ctx.headerCellClickEvent1,
    "empty-text": _ctx.$t('repairManage.noData'),
    pagination: false,
    scroll: {
      y: _ctx.tableScrollY,
      x: 1380
    },
    "row-class-name": (_record, index) => index % 2 === 1 ? 'table-striped' : null,
    onChange: _ctx.handleTableChange
  }, {
    headerCell: _withCtx(({
      column,
      record
    }) => [column.dataIndex === 'citys' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createVNode(_component_a_cascader, {
      ref: "cascaderRef",
      value: _ctx.arrValue,
      "onUpdate:value": _cache[1] || (_cache[1] = $event => _ctx.arrValue = $event),
      style: {
        "width": "100%",
        "border": "1px solid red"
      },
      multiple: "",
      "max-tag-count": "responsive",
      options: _ctx.storeData1.storeLocationConditionList.cityArr,
      placeholder: "Please select",
      onChange: _ctx.cityArrChange
    }, {
      default: _withCtx(() => [_createVNode(_component_FilterFilled, {
        style: {
          "cursor": "pointer"
        }
      })]),
      _: 1
    }, 8, ["value", "options", "onChange"])])) : _createCommentVNode("", true)]),
    customFilterDropdown: _withCtx(({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      column
    }) => [column.dataIndex === 'storeTypeNameZh' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_a_input, {
      ref: "searchInput",
      style: {
        "margin-bottom": "8px",
        "display": "block"
      },
      value: _ctx.storeData1.StoreLocationConditionCheck.storeTypeNameInput,
      "onUpdate:value": _cache[2] || (_cache[2] = $event => _ctx.storeData1.StoreLocationConditionCheck.storeTypeNameInput = $event),
      placeholder: "input search"
    }, null, 8, ["value"]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_checkbox_group, {
      value: _ctx.storeData1.StoreLocationConditionRO[3].condition,
      "onUpdate:value": _cache[3] || (_cache[3] = $event => _ctx.storeData1.StoreLocationConditionRO[3].condition = $event),
      options: _ctx.filteredStoreTypeData,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "gap": "10px"
      }
    }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_a_checkbox, {
      checked: _ctx.storeData1.StoreLocationConditionCheck.storeTypeName,
      "onUpdate:checked": _cache[4] || (_cache[4] = $event => _ctx.storeData1.StoreLocationConditionCheck.storeTypeName = $event),
      indeterminate: _ctx.storeData1.StoreLocationConditionCheck.storeTypeNameIndeterminate,
      onChange: _ctx.onCheckAllChange1
    }, {
      default: _withCtx(() => [_createTextVNode(" 全选 ")]),
      _: 1
    }, 8, ["checked", "indeterminate", "onChange"]), _createVNode(_component_a_button, {
      size: "small",
      type: "primary",
      onClick: $event => {
        _ctx.queryData();
        confirm();
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 查找 ")]),
      _: 2
    }, 1032, ["onClick"])])])) : _createCommentVNode("", true), column.dataIndex === 'supportType' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_a_checkbox_group, {
      value: _ctx.storeData1.StoreLocationConditionRO[8].condition,
      "onUpdate:value": _cache[5] || (_cache[5] = $event => _ctx.storeData1.StoreLocationConditionRO[8].condition = $event),
      options: _ctx.storeData1.storeLocationConditionList.supportType,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "gap": "10px"
      }
    }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_a_checkbox, {
      checked: _ctx.storeData1.StoreLocationConditionCheck.supportType,
      "onUpdate:checked": _cache[6] || (_cache[6] = $event => _ctx.storeData1.StoreLocationConditionCheck.supportType = $event),
      indeterminate: _ctx.storeData1.StoreLocationConditionCheck.supportTypeIndeterminate,
      onChange: _ctx.onCheckAllChange1SupportType
    }, {
      default: _withCtx(() => [_createTextVNode(" 全选 ")]),
      _: 1
    }, 8, ["checked", "indeterminate", "onChange"]), _createVNode(_component_a_button, {
      size: "small",
      type: "primary",
      onClick: $event => {
        _ctx.queryData();
        confirm();
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 查找 ")]),
      _: 2
    }, 1032, ["onClick"])])])) : _createCommentVNode("", true), column.dataIndex === 'ice' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_a_checkbox_group, {
      value: _ctx.storeData1.StoreLocationConditionRO[0].condition,
      "onUpdate:value": _cache[7] || (_cache[7] = $event => _ctx.storeData1.StoreLocationConditionRO[0].condition = $event),
      options: _ctx.storeData1.storeLocationConditionList.aec,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "gap": "10px"
      }
    }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_a_checkbox, {
      checked: _ctx.storeData1.StoreLocationConditionCheck.aec,
      "onUpdate:checked": _cache[8] || (_cache[8] = $event => _ctx.storeData1.StoreLocationConditionCheck.aec = $event),
      indeterminate: _ctx.storeData1.StoreLocationConditionCheck.aecIndeterminate,
      onChange: _ctx.onCheckAllChange1Aec
    }, {
      default: _withCtx(() => [_createTextVNode(" 全选 ")]),
      _: 1
    }, 8, ["checked", "indeterminate", "onChange"]), _createVNode(_component_a_button, {
      size: "small",
      type: "primary",
      onClick: $event => {
        _ctx.queryData();
        confirm();
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 查找 ")]),
      _: 2
    }, 1032, ["onClick"])])])) : _createCommentVNode("", true), column.dataIndex === 'gender' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_a_checkbox_group, {
      value: _ctx.storeData1.StoreLocationConditionRO[4].condition,
      "onUpdate:value": _cache[9] || (_cache[9] = $event => _ctx.storeData1.StoreLocationConditionRO[4].condition = $event),
      options: _ctx.storeData1.storeLocationConditionList.gender,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "gap": "10px"
      }
    }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_a_checkbox, {
      checked: _ctx.storeData1.StoreLocationConditionCheck.gender,
      "onUpdate:checked": _cache[10] || (_cache[10] = $event => _ctx.storeData1.StoreLocationConditionCheck.gender = $event),
      indeterminate: _ctx.storeData1.StoreLocationConditionCheck.genderIndeterminate,
      onChange: _ctx.onCheckAllChange1Gender
    }, {
      default: _withCtx(() => [_createTextVNode(" 全选 ")]),
      _: 1
    }, 8, ["checked", "indeterminate", "onChange"]), _createVNode(_component_a_button, {
      size: "small",
      type: "primary",
      onClick: $event => {
        _ctx.queryData();
        confirm();
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 查找 ")]),
      _: 2
    }, 1032, ["onClick"])])])) : _createCommentVNode("", true), column.dataIndex === 'category' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_a_input, {
      value: _ctx.storeData1.StoreLocationConditionCheck.categoryInput,
      "onUpdate:value": _cache[11] || (_cache[11] = $event => _ctx.storeData1.StoreLocationConditionCheck.categoryInput = $event),
      placeholder: "input search",
      style: {
        "margin-bottom": "8px",
        "display": "block"
      }
    }, null, 8, ["value"]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_a_checkbox_group, {
      value: _ctx.storeData1.StoreLocationConditionRO[1].condition,
      "onUpdate:value": _cache[12] || (_cache[12] = $event => _ctx.storeData1.StoreLocationConditionRO[1].condition = $event),
      options: _ctx.filteredCategory,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "gap": "10px"
      }
    }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_a_checkbox, {
      checked: _ctx.storeData1.StoreLocationConditionCheck.category,
      "onUpdate:checked": _cache[13] || (_cache[13] = $event => _ctx.storeData1.StoreLocationConditionCheck.category = $event),
      indeterminate: _ctx.storeData1.StoreLocationConditionCheck.categoryIndeterminate,
      onChange: _ctx.onCheckAllChange1Category
    }, {
      default: _withCtx(() => [_createTextVNode(" 全选 ")]),
      _: 1
    }, 8, ["checked", "indeterminate", "onChange"]), _createVNode(_component_a_button, {
      size: "small",
      type: "primary",
      onClick: $event => {
        _ctx.queryData();
        confirm();
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 查找 ")]),
      _: 2
    }, 1032, ["onClick"])])])) : _createCommentVNode("", true), column.dataIndex === 'region' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_a_input, {
      value: _ctx.storeData1.StoreLocationConditionCheck.regionInput,
      "onUpdate:value": _cache[14] || (_cache[14] = $event => _ctx.storeData1.StoreLocationConditionCheck.regionInput = $event),
      placeholder: "input search",
      style: {
        "margin-bottom": "8px",
        "display": "block"
      }
    }, null, 8, ["value"]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_a_checkbox_group, {
      value: _ctx.storeData1.StoreLocationConditionRO[7].condition,
      "onUpdate:value": _cache[15] || (_cache[15] = $event => _ctx.storeData1.StoreLocationConditionRO[7].condition = $event),
      options: _ctx.filteredRegion,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "gap": "10px"
      }
    }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_a_checkbox, {
      checked: _ctx.storeData1.StoreLocationConditionCheck.region,
      "onUpdate:checked": _cache[16] || (_cache[16] = $event => _ctx.storeData1.StoreLocationConditionCheck.region = $event),
      indeterminate: _ctx.storeData1.StoreLocationConditionCheck.regionIndeterminate,
      onChange: _ctx.onCheckAllChange1Region
    }, {
      default: _withCtx(() => [_createTextVNode(" 全选 ")]),
      _: 1
    }, 8, ["checked", "indeterminate", "onChange"]), _createVNode(_component_a_button, {
      size: "small",
      type: "primary",
      onClick: $event => {
        _ctx.queryData();
        confirm();
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 查找 ")]),
      _: 2
    }, 1032, ["onClick"])])])) : _createCommentVNode("", true), column.dataIndex === 'location' ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_a_input, {
      value: _ctx.storeData1.StoreLocationConditionCheck.locationInput,
      "onUpdate:value": _cache[17] || (_cache[17] = $event => _ctx.storeData1.StoreLocationConditionCheck.locationInput = $event),
      placeholder: "input search",
      style: {
        "margin-bottom": "8px",
        "display": "block"
      }
    }, null, 8, ["value"]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_a_checkbox_group, {
      value: _ctx.storeData1.StoreLocationConditionRO[5].condition,
      "onUpdate:value": _cache[18] || (_cache[18] = $event => _ctx.storeData1.StoreLocationConditionRO[5].condition = $event),
      options: _ctx.filteredLocation,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "gap": "10px"
      }
    }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_a_checkbox, {
      checked: _ctx.storeData1.StoreLocationConditionCheck.location,
      "onUpdate:checked": _cache[19] || (_cache[19] = $event => _ctx.storeData1.StoreLocationConditionCheck.location = $event),
      indeterminate: _ctx.storeData1.StoreLocationConditionCheck.locationIndeterminate,
      onChange: _ctx.onCheckAllChange1Location
    }, {
      default: _withCtx(() => [_createTextVNode(" 全选 ")]),
      _: 1
    }, 8, ["checked", "indeterminate", "onChange"]), _createVNode(_component_a_button, {
      size: "small",
      type: "primary",
      onClick: $event => {
        _ctx.queryData();
        confirm();
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 查找 ")]),
      _: 2
    }, 1032, ["onClick"])])])) : _createCommentVNode("", true), column.dataIndex === 'locationSummary' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 7
    }, [_createVNode(_component_a_input, {
      ref: "searchInput",
      style: {
        "margin-bottom": "8px",
        "display": "block"
      },
      value: _ctx.storeData1.StoreLocationConditionCheck.locationSummaryInput,
      "onUpdate:value": _cache[20] || (_cache[20] = $event => _ctx.storeData1.StoreLocationConditionCheck.locationSummaryInput = $event),
      placeholder: "input search"
    }, null, 8, ["value"]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createVNode(_component_a_checkbox_group, {
      value: _ctx.storeData1.StoreLocationConditionRO[6].condition,
      "onUpdate:value": _cache[21] || (_cache[21] = $event => _ctx.storeData1.StoreLocationConditionRO[6].condition = $event),
      options: _ctx.filteredLocationSummary,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "gap": "10px"
      }
    }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_32, [_createVNode(_component_a_checkbox, {
      checked: _ctx.storeData1.StoreLocationConditionCheck.locationSummary,
      "onUpdate:checked": _cache[22] || (_cache[22] = $event => _ctx.storeData1.StoreLocationConditionCheck.locationSummary = $event),
      indeterminate: _ctx.storeData1.StoreLocationConditionCheck.locationSummaryIndeterminate,
      onChange: _ctx.onCheckAllChange1LocationSummary
    }, {
      default: _withCtx(() => [_createTextVNode(" 全选 ")]),
      _: 1
    }, 8, ["checked", "indeterminate", "onChange"]), _createVNode(_component_a_button, {
      size: "small",
      type: "primary",
      onClick: $event => {
        _ctx.queryData();
        confirm();
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 查找 ")]),
      _: 2
    }, 1032, ["onClick"])])])], 64)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["columns", "data-source", "loading", "onHeaderCellClick", "empty-text", "scroll", "row-class-name", "onChange"])) : _createCommentVNode("", true)], 512), _createElementVNode("div", _hoisted_33, [_createVNode(_component_a_pagination, {
    current: _ctx.storeData1.paginationData.currentPage,
    "onUpdate:current": _cache[23] || (_cache[23] = $event => _ctx.storeData1.paginationData.currentPage = $event),
    "page-size": _ctx.storeData1.paginationData.pageSize,
    "onUpdate:pageSize": _cache[24] || (_cache[24] = $event => _ctx.storeData1.paginationData.pageSize = $event),
    total: _ctx.storeData1.paginationData.totalSize,
    "show-total": total => `Total ${total} items`,
    showQuickJumper: false,
    showSizeChanger: false,
    showLessItems: false
  }, null, 8, ["current", "page-size", "total", "show-total"])])])]);
}